export default {
  text: 'Hai effettuato un ordine meno di 15 minuti fa! Conferma se desideri procedere con questo nuovo ordine o gestire quello esistente.',
  buttons: {
    see_existing_order: 'Vedi ordine esistente',
    proceed_new_order: 'Procedi con il nuovo ordine',
  },
};
